module.exports = __webpack_public_path__ + "img/universal-model.0ca6cdfe.png";